<template>
  <div class="cityPortalList">
    <div class="card cityPortal">
      <div class="more" @click="showOrHide()">
        <span>地市门户&nbsp;<i class="el-icon-arrow-down" /></span>
      </div>
      <div class="cityPortalContent" v-show="showItem">
        <template v-for="site in siteList">
          <div class="cityPortalListItem" :key="site.site" @click="() => {goToSite(site.site)}">
            {{ site.siteName }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import { getSiteInfo } from '@/api/site'
export default {
  name: 'CityPortalList',
  data() {
    return {
      siteList: [{ site: 'zzPortal', siteName: '漳州市' }],
      showItem: false
    }
  },
  mounted() {
    // getSiteInfo().then(res => {
    //   this.siteList = res.filter(item => item.site != '' && item.site != 'main')
    // })
    window.addEventListener('click', this.windowClick)
  },
  methods: {
    goToSite(site) {
      let host = window.location.host;
      // let dynamicConfig = localStorage.dynamicConfig;
      let protocal = this.$isHttps ? "https://" : "http://";
      let url = protocal + host + `/${site}`;
      this.showItem = false
      window.open(url, "_blank");
    },
    showOrHide() {
      this.showItem = this.showItem ? false : true
    },
    windowClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showItem = false
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('click', this.windowClick)
  }
}
</script>

<style lang="scss" scoped>
  .cityPortalList {
    display: inline-block;
    .card {
      z-index: 9990;
      height: 35px;
      display: inline-block;
      width: 120px;
      &.cityPortal {
        position: relative;
      }
      .more {
        // border: 1px solid #bfd6c7;
        // background-color: #1ca868;
        // border-radius: 5px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #000;
        &:hover {
          // border: 1px solid #1ca868;
          cursor: pointer;
        }
      }
      .cityPortalContent {
        position: absolute;
        border-radius: 5px;
        border: 1px solid #ebeef5;
        width: 120px;
        .cityPortalListItem {
          padding: 0px 10px;
          height: 35px;
          background-color: #fff;
          line-height: 35px;
          color: #1ca868;
          &:hover {
            // border: 1px solid #1ca868;
            background-color: #1ca868;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }

</style>